export const skeletonSiteTypesList = [{ available_sites: '2', name: 'Loading...', type: 'type_rv_site' }]
